<ng-container [formGroup]="form">
  <dgx-form-fieldset
    [legend]="legend"
    [legendDisplayAsLabel]="legendDisplayAsLabel"
    [legendHidden]="legendHidden"
    [legendNote]="legendNote"
  >
    <dgx-form-row>
      <dgx-form-field
        [dgxFormField]="paperlessPreferenceField"
        dgxGaFormField
        formControlName="paperlessPreference"
      >
        <dgx-form-checkbox [size]="'medium'" />
      </dgx-form-field>
    </dgx-form-row>

    <div *ngIf="paperlessPreferenceBanner" class="mt-6">
      <dgx-components-panel variant="primary-alternative">
        {{ paperlessPreferenceBanner }}
      </dgx-components-panel>
    </div>
  </dgx-form-fieldset>
</ng-container>
